import script from "./userInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./userInformation.vue?vue&type=script&setup=true&lang=js"

import "./userInformation.vue?vue&type=style&index=0&id=39bf6f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39bf6f4c"]])

export default __exports__